import { NextPage, NextPageContext } from "next";
import GetSupportLP from "@containers/GetSupportLP";
import Footer from "@layouts/Footer";
import { canonicalLink } from "@helpers/url";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { fetchGenerateToken } from "@libraries/api/generate-token/generate-token.repos";
import { getFaqList } from "@libraries/api/faq-list/faq-list.repos";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";

const PageBantuanWithTopic: NextPage<any> = ({ dataNavbar, dataFaq, lang }) => {
  const languageTitle = lang === "id" ? "Performa" : "Performance";
  return (
    <>
      <GetSupportLP dataFaq={dataFaq} topic={languageTitle} />
      <Footer dataNavbar={dataNavbar} />
    </>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const clientId = `${process.env.CLIENT_ID}`;
  const clientSecret = `${process.env.CLIENT_SECRET}`;
  const lang = `${context.locale}`;
  const searchQuery = `${context.query?.search}`;
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, lang);
  const { data: dataToken } = await fetchGenerateToken({ clientId, clientSecret });

  /** Set parameter to pass over API List FAQ based on search & topic */
  let params;
  if (searchQuery && searchQuery !== "undefined") {
    params = {
      search: searchQuery,
      topic: "performance",
    };
  } else {
    params = {
      topic: "performance",
    };
  }

  const token = dataToken.accessToken;
  const { data: dataFaqResp } = await getFaqList(params, token, lang);

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: "Bantuan - Performa",
      description:
        "Bantuan dan dukungan kami akan membantu menyelesaikan berbagai kendala pada bisnis Anda.",
      canonical: canonicalLink(`/bantuan/performa`, lang),
      dataNavbar: dataProductMenu,
      dataFaq: dataFaqResp,
      lang,
    },
  };
}

export default PageBantuanWithTopic;
